import { render, staticRenderFns } from "./ModelTagTypeTabs.vue?vue&type=template&id=37d4ec6f"
import script from "./ModelTagTypeTabs.vue?vue&type=script&lang=ts"
export * from "./ModelTagTypeTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports